import { useObservableState } from 'observable-hooks';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { map } from 'rxjs/operators';
import OptionModal from '../../../../components/modals/option-modal';

import {
  CROP_FIELDS_AND_WORKS_INDEX,
  CROP_WORK_EDIT,
} from '../../../../router/routes';
import { useService } from '../../../../services/services';
import { route } from '../../../../services/utils';
import { FormData, workToFormData } from './create';
import StepOverview from './step-overview';
import { Section as FieldsAndWorksSection } from '../../../../pages/crop/fields-and-works';

export default function ViewWork() {
  const history = useHistory();
  const [modal, setModal] = useState(null);
  const { t } = useTranslation();
  const tp = useCallback(
    (key: string) => t('pages.crop.works.'.concat(key)),
    [t]
  );
  const { workService } = useService();

  const { farmId, season, id } = useParams<{
    farmId: string;
    season: string;
    id: string;
  }>();

  const deleteWorkModal = useCallback(() => {
    return (
      <OptionModal
        title={tp('delete')}
        content={tp('confirm_delete')}
        buttons={[
          { title: t('yes'), name: 'yes', value: true },
          { title: t('no'), name: 'no', value: false },
        ]}
        onChoice={(choice) => {
          if (choice) {
            workService.destroy(farmId, id).subscribe(() => {
              history.push(
                route(CROP_FIELDS_AND_WORKS_INDEX, {
                  farmId: farmId,
                  season: season,
                  tab: FieldsAndWorksSection.workOverview,
                })
              );
            });
          }

          setModal(null);
        }}
        onClose={() => setModal(null)}
      />
    );
  }, [t, tp, workService, farmId, season, id, history]);

  const onDelete = useCallback(() => {
    setModal(deleteWorkModal);
  }, [deleteWorkModal]);

  const [formData] = useObservableState<FormData>(
    () =>
      workService.show(farmId, id).pipe(
        map((work) => {
          return workToFormData(work);
        })
      ),
    null
  );

  const onEdit = () => {
    history.push(
      route(CROP_WORK_EDIT, {
        farmId: farmId,
        season: season,
        id: formData.id,
      })
    );
  };

  return (
    formData && (
      <>
        <StepOverview formData={formData} onEdit={onEdit} onDelete={onDelete} />
        {modal}
      </>
    )
  );
}
